import { render } from "./HuntBioCard.vue?vue&type=template&id=46651298&scoped=true"
import script from "./HuntBioCard.vue?vue&type=script&lang=js"
export * from "./HuntBioCard.vue?vue&type=script&lang=js"

import "./HuntBioCard.vue?vue&type=style&index=0&id=46651298&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46651298"],['__file',"HuntBioCard.vue"]])

export default __exports__